import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import rest from '../../../lib/rest'
import FormFornecedor from './formFornecedor'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import CentralLojas from '../../../components/CentralLojas'
import useCentralLojas from '../../../lib/useCentralLojas'
import Loading from 'lib/loading'
import './style.css'

const Fornecedores = ()=> {

  const colunas = [
    {
      dataField: 'fornecedor_id',
      text: 'Código',
      align: 'center'
    },
    {
      dataField: 'fornecedor',
      text: 'Fornecedor',
      align: 'rigth'
    },
    {
      dataField: 'forn_cnpj',
      text: 'CNPJ'
    },
    {
      dataField: 'forn_uf',
      text: 'UF'
    },
    {
      dataField: 'desconto_maximo',
      text: 'Desconto',
      formatter: (cellContent, row) => {
        if (row.desconto_maximo) {
          return row.desconto_maximo.replace('.', ',')+' %'
        }
        return '0,00 %'
      }
    },
    {
      dataField: 'padrao_comissao',
      text: 'Comissão',
      formatter: (cellContent, row) => {
        if (row.padrao_comissao) {
          return row.padrao_comissao.replace('.', ',')+' %'
        }
        return ''
      }
    },
    {
      dataField: 'fantasia',
      text: 'Central'
    }
  ]

  const { SearchBar }                         = Search
  const [loading, setLoading]                 = useState(true)
  const [modal, setModal]                     = useToggle()
  const [fornecedor_id, setFornecedor_id]     = useState('')
  const [filial_id, setFilial_id]             = useState('')
  const [listaFornecedor, setListaFornecedor] = useState([])

  const listaFornecedores = () => {
      let lista = []
      try{
        const retorno = rest.get(rotas.fornecedor+useCentralLojas.centralLoja().filial_id)
        retorno.then(ret => {
          if (ret !== '' && ret.success && ret.success === 'S' && ret.lista !== null){
            lista = ret.lista
            setListaFornecedor(lista)
          }
          setLoading(false);
        })
        return (lista)

      }catch(err){
        return (false)
      }
  }

  useEffect(() => {
    //listaCentral()
    listaFornecedores()
  }, [useCentralLojas.centralLoja().filial_id]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(modal===false){
      listaFornecedores()
    }
  }, [modal])

  //abrir modal do formulario
  const abreModal = (filial_id, fornecedor_id) => {
    setFornecedor_id(fornecedor_id)
    setFilial_id(filial_id)
    setModal()
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>CADASTRO DE FORNECEDORES</CardTitle>
                    </Col>

                    <CentralLojas
                      refresh = {setFilial_id}
                    >
                    </CentralLojas>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Modal
                    size   = 'xl'
                    isOpen = {modal}
                  >
                    <ModalHeader>Cadastro de Fornecedores</ModalHeader>
                    <FormFornecedor
                      filial_id     = {useCentralLojas.centralLoja().filial_id}
                      fornecedor_id = {fornecedor_id}
                      fechaModal    = {setModal}
                    ></FormFornecedor>
                  </Modal>
                  <ToolkitProvider
                    keyField  = "fornecedor_id"
                    data      = {listaFornecedor}
                    columns   = {colunas}
                    search
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  outline
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal(filial_id,'')}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Fornecedor..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            //remote - paginação remota pelo banco
                            keyField         = 'fornecedor_id'
                            noDataIndication = "Nenhum registro encontrado"
                            rowStyle         = {{ cursor: "pointer" }}
                            pagination       = {paginationFactory({
                                                  sizePerPage: 10,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            rowEvents        = {{
                                                onDoubleClick: (e, row, rowIndex) => {
                                                  abreModal(filial_id, row.fornecedor_id)
                                                }
                                              }}
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Fornecedores
